import guest from "./guest";
import inviteGuest from "./inviteGuest";

export default {
    guest,
    inviteGuest
}
